module.exports = __webpack_public_path__ + "img/1f400.cbaa982.svg";